import Component from 'flarum/common/Component';
import Link from 'flarum/common/components/Link';
import app from 'flarum/forum/app';
import { avatar, icon } from './ui';
const SORTS = {
  latest: {
    label: 'Ostatnio aktywne',
    api: '-lastPostedAt'
  },
  newest: {
    label: 'Najnowsze tematy',
    api: '-createdAt'
  },
  top: {
    label: 'Najwięcej odpowiedzi',
    api: '-commentCount'
  }
};
const safeCall = function (target, method, fallback) {
  if (fallback === void 0) {
    fallback = null;
  }
  try {
    return target && typeof target[method] === 'function' ? target[method]() : fallback;
  } catch {
    return fallback;
  }
};
const discussionHref = discussion => {
  const id = String(safeCall(discussion, 'id', '') || '');
  const slug = String(safeCall(discussion, 'slug', '') || '').trim();
  return app.route('discussion', {
    id: slug ? `${id}-${slug}` : id
  });
};
const relativeTime = value => {
  if (!value) return 'brak daty';
  const date = value instanceof Date ? value : new Date(value);
  const timestamp = date.getTime();
  if (!Number.isFinite(timestamp)) return 'brak daty';
  const seconds = Math.max(0, Math.floor((Date.now() - timestamp) / 1000));
  if (seconds < 45) return 'przed chwilą';
  const minutes = Math.floor(seconds / 60);
  if (minutes < 60) return `${minutes} min temu`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours} godz. temu`;
  const days = Math.floor(hours / 24);
  if (days < 30) return `${days} ${days === 1 ? 'dzień' : 'dni'} temu`;
  return new Intl.DateTimeFormat('pl-PL', {
    day: '2-digit',
    month: 'short',
    year: 'numeric'
  }).format(date);
};
export default class HomeDiscussionFeed extends Component {
  discussions = [];
  loading = true;
  error = '';
  sort = 'latest';
  requestId = 0;
  oninit(vnode) {
    super.oninit(vnode);
    this.load();
  }
  async load() {
    const requestId = ++this.requestId;
    this.loading = true;
    this.error = '';
    m.redraw();
    try {
      const rows = await app.store.find('discussions', {
        sort: SORTS[this.sort].api,
        include: 'user,lastPostedUser,tags',
        page: {
          limit: 7
        }
      });
      if (requestId !== this.requestId) return;
      this.discussions = Array.isArray(rows) ? rows : [];
    } catch (error) {
      if (requestId !== this.requestId) return;
      this.error = 'Nie udało się pobrać najnowszych dyskusji.';
      this.discussions = [];
      console.error('[NovaTruck] Home discussion feed:', error);
    } finally {
      if (requestId === this.requestId) {
        this.loading = false;
        m.redraw();
      }
    }
  }
  setSort(value) {
    if (!Object.prototype.hasOwnProperty.call(SORTS, value)) return;
    this.sort = value;
    this.load();
  }
  renderDiscussion(discussion) {
    const title = String(safeCall(discussion, 'title', 'Bez tytułu') || 'Bez tytułu');
    const user = safeCall(discussion, 'user');
    const lastUser = safeCall(discussion, 'lastPostedUser') || user;
    const author = String(safeCall(user, 'displayName', safeCall(user, 'username', 'Użytkownik')) || 'Użytkownik');
    const lastAuthor = String(safeCall(lastUser, 'displayName', safeCall(lastUser, 'username', author)) || author);
    const commentCount = Number(safeCall(discussion, 'commentCount', 0) || 0);
    const unreadCount = Number(safeCall(discussion, 'unreadCount', 0) || 0);
    const lastPostedAt = safeCall(discussion, 'lastPostedAt') || safeCall(discussion, 'createdAt');
    const tags = safeCall(discussion, 'tags', []) || [];
    const firstTag = Array.isArray(tags) && tags.length ? tags[0] : null;
    const tagName = firstTag ? String(safeCall(firstTag, 'name', '') || '') : '';
    const tagColor = firstTag ? String(safeCall(firstTag, 'color', '#d7a83b') || '#d7a83b') : '#d7a83b';
    const isSticky = Boolean(safeCall(discussion, 'isSticky', false));
    const isLocked = Boolean(safeCall(discussion, 'isLocked', false));
    return m("article", {
      className: "NtDiscussionFeed-item",
      style: {
        '--discussion-accent': tagColor
      }
    }, m(Link, {
      className: "NtDiscussionFeed-avatar",
      href: discussionHref(discussion),
      "aria-label": `Otwórz dyskusję ${title}`
    }, avatar(lastUser || user, {
      className: 'Avatar'
    }), unreadCount > 0 && m("span", {
      className: "NtDiscussionFeed-unread",
      title: `${unreadCount} nieprzeczytanych`
    })), m("div", {
      className: "NtDiscussionFeed-body"
    }, m("div", {
      className: "NtDiscussionFeed-titleline"
    }, m(Link, {
      className: "NtDiscussionFeed-title",
      href: discussionHref(discussion)
    }, title), isSticky && m("span", {
      className: "NtDiscussionFeed-state",
      title: "Przypi\u0119ty"
    }, icon('fas fa-thumbtack')), isLocked && m("span", {
      className: "NtDiscussionFeed-state",
      title: "Zamkni\u0119ty"
    }, icon('fas fa-lock'))), m("div", {
      className: "NtDiscussionFeed-meta"
    }, tagName && m("span", {
      className: "NtDiscussionFeed-tag",
      style: {
        '--tag-color': tagColor
      }
    }, tagName), m("span", null, "Autor: ", m("strong", null, author)), m("span", {
      className: "NtDiscussionFeed-dot"
    }, "\u2022"), m("span", null, "Ostatnio: ", m("strong", null, lastAuthor)), m("span", {
      className: "NtDiscussionFeed-dot"
    }, "\u2022"), m("span", null, relativeTime(lastPostedAt)))), m(Link, {
      className: "NtDiscussionFeed-count",
      href: discussionHref(discussion),
      "aria-label": `${commentCount} odpowiedzi`
    }, icon('far fa-comment'), m("strong", null, commentCount), m("small", null, commentCount === 1 ? 'odpowiedź' : 'odpowiedzi')));
  }
  view() {
    return m("section", {
      className: "NtDiscussionFeed NtCard",
      "aria-label": "Najnowsze dyskusje"
    }, m("header", {
      className: "NtDiscussionFeed-head"
    }, m("div", null, m("small", null, "AKTYWNO\u015A\u0106 SPO\u0141ECZNO\u015ACI"), m("h2", null, "Najnowsze dyskusje")), m("div", {
      className: "NtDiscussionFeed-controls"
    }, m("label", null, m("span", {
      className: "sr-only"
    }, "Sortowanie dyskusji"), m("select", {
      value: this.sort,
      onchange: event => this.setSort(event.target.value)
    }, Object.keys(SORTS).map(key => m("option", {
      value: key
    }, SORTS[key].label)))), m("button", {
      type: "button",
      className: this.loading ? 'is-loading' : '',
      title: "Od\u015Bwie\u017C dyskusje",
      "aria-label": "Od\u015Bwie\u017C dyskusje",
      onclick: () => this.load(),
      disabled: this.loading
    }, icon('fas fa-sync-alt')))), m("div", {
      className: "NtDiscussionFeed-list",
      "aria-live": "polite"
    }, this.loading && this.discussions.length === 0 ? [0, 1, 2].map(key => m("div", {
      className: "NtDiscussionFeed-skeleton",
      key: key
    }, m("span", null), m("div", null, m("i", null), m("i", null)), m("b", null))) : null, !this.loading && this.error && m("div", {
      className: "NtDiscussionFeed-empty is-error"
    }, icon('fas fa-exclamation-triangle'), m("strong", null, this.error), m("button", {
      type: "button",
      onclick: () => this.load()
    }, "Spr\xF3buj ponownie")), !this.loading && !this.error && this.discussions.length === 0 && m("div", {
      className: "NtDiscussionFeed-empty"
    }, icon('far fa-comments'), m("strong", null, "Nie ma jeszcze dyskusji."), m("span", null, "Rozpocznij pierwsz\u0105 rozmow\u0119 z menu po lewej stronie.")), this.discussions.map(discussion => this.renderDiscussion(discussion))), m("footer", {
      className: "NtDiscussionFeed-footer"
    }, m(Link, {
      href: "/tags",
      className: "Button"
    }, "Przegl\u0105daj wszystkie dzia\u0142y ", icon('fas fa-arrow-right'))));
  }
}
flarum.reg.add('novatruck-theme', 'forum/components/HomeDiscussionFeed', HomeDiscussionFeed);